import { useNavigate } from "react-router-dom";
import { PaidMedicalLeaveRequestSubmitted } from "./PaidMedicalLeaveRequestSubmitted";


export const PaidMedicalLeaveRequestSubmittedRoute = () => {
  const navigate = useNavigate();
  return (
    <PaidMedicalLeaveRequestSubmitted
      onClose={() => navigate('/')}
    />
  )
}